// TODO (LEMS-3815): Remove this file
const styles = {
    inputWithExamples: {
        borderRadius: "0.3rem",
        borderWidth: "var(--wb-border-width-thin)",
        direction: "ltr",
        display: "inline-block",
        fontFamily: 'Symbola, "Times New Roman", serif',
        fontSize: "1.8rem",
        height: "3.2rem",
        lineHeight: "1.8rem",
        padding: "0.4rem 0.5rem",
        textAlign: "left",
        width: "8rem",
    },
    isFocused: {
        borderWidth: "var(--wb-border-width-medium)",
        padding: "0.4rem",
    },
    rightAlign: {textAlign: "right"},
    sizeSmall: {width: "4rem"},
};

export default styles;
